module.exports = "/app/main/img/extra-insurance-v2.aad2db09.png";